import { __assign, __makeTemplateObject, __read, __rest } from "tslib";
import React, { forwardRef, memo, useMemo, useState, } from 'react';
import MuiMenu from '@material-ui/core/Menu';
import { combineClasses, styled, useEventCallback, useId, useRcPortalWindowContext, useThemeProps, } from '../../../foundation';
import { RcMenuContext } from './MenuContext';
import { MenuStyle } from './styles';
import { RcMenuClasses } from './utils';
var MemoMuiMenu = memo(MuiMenu);
var _RcMenu = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcMenu' });
    var classesProp = props.classes, children = props.children, autoClose = props.autoClose, onClose = props.onClose, rest = __rest(props, ["classes", "children", "autoClose", "onClose"]);
    var _a = __read(useState(null), 2), focusedMenuItemId = _a[0], setFocusedMenuItemId = _a[1];
    var id = useId('menu-', true);
    var externalWindow = useRcPortalWindowContext().externalWindow;
    var classes = useMemo(function () { return combineClasses(RcMenuClasses, classesProp); }, [classesProp]);
    var handleClose = useEventCallback(function (event, reason) {
        onClose === null || onClose === void 0 ? void 0 : onClose(event, reason);
    });
    var ctxValue = useMemo(function () { return ({
        menuId: id,
        autoClose: !!autoClose,
        focusedMenuItemId: focusedMenuItemId,
        setFocusedMenuItemId: setFocusedMenuItemId,
        closeMenu: handleClose,
    }); }, [autoClose, focusedMenuItemId, handleClose, id]);
    return (React.createElement(RcMenuContext.Provider, { value: ctxValue },
        React.createElement(MemoMuiMenu, __assign({ container: externalWindow === null || externalWindow === void 0 ? void 0 : externalWindow.document.body }, rest, { ref: ref, classes: classes, onClose: handleClose, disableEnforceFocus: true }), children)));
});
var RcMenu = styled(_RcMenu)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), MenuStyle);
RcMenu.defaultProps = {
    variant: 'selectedMenu',
    getContentAnchorEl: null,
    anchorReference: 'anchorEl',
    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
};
RcMenu.displayName = 'RcMenu';
export { RcMenu, RcMenuContext };
var templateObject_1;
